// Client Version
export const version = "1.7.0"

export const DomainName = "https://www.stage-plus.com/"

export enum Platform {
  Tizen = "Tizen",
  WebOS = "WebOS",
  Chromecast = "Chromecast",
  Web = "web",
}

export const platform: Platform = window.navigator.userAgent.includes("Tizen")
  ? Platform.Tizen
  : window.navigator.userAgent.includes("Web0S")
    ? Platform.WebOS
    : window.cast && window.cast?.framework
      ? Platform.Chromecast
      : Platform.Web

enum TizenButtons {
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Enter = 13,
  Back = 10009,
  PlayPause = 10252,
  Play = 415,
  Pause = 19,
  Stop = 413,
  FF = 417,
  Rewind = 412,
}

enum WebosButtons {
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Enter = 13,
  Back = 461,
  Play = 415,
  Pause = 19,
  Stop = 413,
  FF = 417,
  Rewind = 412,
}

enum WebButtons {
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Enter = 13,
  Back = 112,
  Play = 113,
  PlayPause = 117,
  Pause = 114,
  Stop = 119,
  FF = 116,
  Rewind = 115,
}

enum ChromecastButtons {
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
  Enter = 13,
  Back = 0,
  Play = 179,
  PlayPause = 179,
  Pause = 114,
  Stop = 178,
  FF = 228,
  Rewind = 227,
}

export const keyup = platform === Platform.Chromecast ? "ccKeyUp" : "keyup"
export const keydown =
  platform === Platform.Chromecast ? "ccKeyDown" : "keydown"

export enum InputDeviceKey {
  MediaPlayPause = "MediaPlayPause",
  MediaRewind = "MediaRewind",
  MediaFastForward = "MediaFastForward",
  MediaPlay = "MediaPlay",
  MediaPause = "MediaPause",
  MediaStop = "MediaStop",
  MediaRecord = "MediaRecord",
  ColorF0Red = "ColorF0Red",
}

// fake platforming here
export const Buttons =
  platform === Platform.WebOS
    ? WebosButtons
    : platform === Platform.Web
      ? WebButtons
      : platform === Platform.Chromecast
        ? ChromecastButtons
        : TizenButtons

export const supportedLocale = ["en", "de", "ja"]

export const windowLocale = window.navigator.language.substring(0, 2)
export const locale =
  window.localStorage.getItem("locale") ??
  (supportedLocale.includes(windowLocale) ? windowLocale : undefined)

export const dimensions = {
  width: window.innerWidth,
  height: window.innerHeight,
}
export const deviceResolution = window.innerHeight
export const nonStandardFormat =
  deviceResolution !== 1080 && deviceResolution !== 720

export const maxSliderSize = 7 // increased from 7 to 10 because of the new WeeklyTop10 slider

export const privacyLink = "https://www.stage-plus.tv/security-and-privacy"
export const canPlayFlacAudio =
  platform === Platform.Web || platform === Platform.Chromecast

export const env = {
  prod: {
    env: "prod" as "prod" | "staging",
    backendUri: process.env.REACT_APP_PROD_BACKEND_URI!,
    muxKey: process.env.REACT_APP_PROD_MUX_KEY!,
    mixpanelToken: process.env.REACT_APP_PROD_MIXPANEL_TOKEN!,
    sentry: process.env.REACT_APP_SENTRY!,
  },
  staging: {
    env: "staging" as "prod" | "staging",
    backendUri: process.env.REACT_APP_STAGING_BACKEND_URI!,
    muxKey: process.env.REACT_APP_STAGING_MUX_KEY!,
    mixpanelToken: process.env.REACT_APP_STAGING_MIXPANEL_TOKEN!,
    sentry: process.env.REACT_APP_SENTRY!,
  },
}[
  process.env.REACT_APP_TEST
    ? "staging"
    : ((window.localStorage.getItem("env") as "prod" | "staging") ?? "prod")
]

export type LGMouseEvent = {
  detail: {
    visibility: boolean
  }
}

export const getChromiumVersion = () => {
  const match = window.navigator.userAgent.match(
    platform === Platform.Tizen ? /\b(\d+)\.\d+\.\d+\.\d+\b/ : /Chrome\/(\d+)/,
  )
  const version = match ? parseInt(match[1], 10) : undefined
  return typeof version === "number" ? version : undefined
}

// set value in window to avoid senseless operations
const fontSizeFactorStorage = window.localStorage.getItem(
  "dg_accessibility_fontsize",
)
export const fontSizeFactorStep =
  fontSizeFactorStorage && typeof parseInt(fontSizeFactorStorage) === "number"
    ? parseInt(fontSizeFactorStorage)
    : 2
const fontSizeFactorCalc = { 1: 0.9, 2: 1, 3: 1.1, 4: 1.2, 5: 1.3 }[
  fontSizeFactorStep
] as number

if (!window.fontSizeFactor) window.fontSizeFactor = fontSizeFactorCalc
export const fontSizeFactor = window.fontSizeFactor
